export default {
    root: ({ props, context, parent, instance }) => ({
        class: [
            'avatar-group-root',
        ],
    }),
};